var fontSizes = {
    display: {
        lg: "96px",
        md: "64px",
        sm: "56px",
        xs: "48px",
    },
    heading: {
        xxxl: "34px",
        xxl: "28px",
        xl: "24px",
        lg: "20px",
        md: "18px",
        sm: "16px",
        xs: "14px",
        xxs: "12px",
    },
    label: {
        md: "16px",
        sm: "14px",
        xs: "12px",
    },
    paragraph: {
        xxxl: "34px",
        xxl: "28px",
        xl: "24px",
        lg: "20px",
        md: "16px",
        sm: "14px",
        xs: "12px",
    },
};

export { fontSizes as default };
//# sourceMappingURL=fontSizes.js.map
